import * as React from "react";

import "./styles.css";

const LargeDivisor = () => (
  <div className="row">
    <div className="col-md-12">
      <div styleName="large-divisor"></div>
    </div>
  </div>
);

export default LargeDivisor;
